import React, { Component } from 'react';
import { Field, withShouldComponentUpdate } from '../Forms';
import pick from 'lodash/pick';

import Select from 'antd/lib/Select';
import 'antd/lib/Select/style/css';

class MultiSelect extends Component {
  render() {
    const { name, options, defaultValue, validate, required, id, className, children, selectLabel, emptyOption, multiple } = this.props;
    return (
      <Field
        name={name}
        defaultValue={defaultValue}
        validate={validate}
        required={required}
        component={({ value, trigger })=> {
          return (
            <Select
              id={id}
              className={className}
              name={name}
              value={value || []}
              mode="multiple"
              onChange={(value)=> {
                trigger([
                  { type: 'onChange', value },
                  { type: 'onValidate' },
                  { type: 'onTouched' },
                  { type: 'onDirty' }
                ]);
              }}
            >
              {options ? options.map((option)=>{
                if(typeof option === 'string'){
                  return <Select.Option value={option} key={option}>{option}</Select.Option>
                }
                const { label, ...props } = option;
                const allowedProps = pick(props, ['disabled', 'label', 'selected', 'value']);
                return (<Select.Option {...allowedProps} key={props.value}>{label || option.value}</Select.Option>);
              }) : children}

            </Select>
          )
        }}/>
    )
  }
}

export default withShouldComponentUpdate(MultiSelect);




// WEBPACK FOOTER //
// ./src/app/components/Forms/fields/MultiSelect.js